import React, { Component } from 'react';
import { Navbar, NavbarBrand, Button, ButtonGroup } from 'reactstrap';
import { connect } from 'react-redux';

import ChoiceWidget from '../components/ChoiceWidget';
import AmountSelector from '../components/Navbar/AmountSelector';

import {selectPane, selectSurface, selectColor, showCopyrightModal} from "../actions";

import _each from 'lodash/each';

class Header extends Component {

  state = {
    modal: false
  }

  constructor(props) {
    super(props);
    this.handleSelectSurface = this.handleSelectSurface.bind(this);
    this.handleSelectColor = this.handleSelectColor.bind(this);
    this.renderCheckoutButton = this.renderCheckoutButton.bind(this);
    this.handleSelectProduct = this.handleSelectProduct.bind(this);
    this.renderPrice = this.renderPrice.bind(this);
  }

  handleSelectSurface(surface) {
    return () => {
      this.props.selectSurface(surface);
    };
  }

  handleSelectColor(color) {
    this.props.selectColor(color);
  }

  handleSelectProduct(product) {
    if (window.confirm('編集中のデータは削除されますが、商品を変更してもよろしいですか?')) {
      window.location.href = '/designer-' + product.id;
    }
  }

  renderCheckoutButton() {
    if (this.props.products.totalAmount === 0 || (this.props.objects.present.collision || []).length !== 0) {
      return (
        <button className="btn btn-success" data-tip="数量を選択してください" data-type="warning" data-place="bottom">
          {this.props.system.checkoutLabel}
        </button>
      );
    }

    return (
      <button className="btn btn-success" onClick={this.props.showCopyrightModal} disabled={this.props.products.totalAmount === 0}>
        {this.props.system.checkoutLabel}
      </button>
    );
  }

  renderPrice() {
    if (!this.props.system.showPrice) {
      return;
    }

    let unitPrice = this.props.products.currentItem.price;

    _each(this.props.objects.present.surfaces, (surface) => {
      const hasObjects = (Object.keys(this.props.objects.present.objects[surface.surface.id]).length) > 0;

      if (hasObjects) {
        unitPrice += surface.surface.price;
      }
    });

    const totalPrice = new Intl.NumberFormat('ja-JP').format(Math.floor(unitPrice * 1.1) * this.props.products.totalAmount);

    return (
      <div className="t-container-header-right-section">
        <div className="t-container-header-label">合計金額(税込)</div>
        <div>
          <strong>{totalPrice}</strong> 円
        </div>
      </div>
    );
  }

  render() {
    return (
      <Navbar light color="light" className="t-container-header">
        <NavbarBrand href="/">
          <img src={window.tProjectGlobals.assetBaseUrl + "img/logo.jpg"} alt="ORI-HIRO" /></NavbarBrand>

        <div className="t-container-header-section">
          <div className="t-container-header-label">アイテム</div>
          <ChoiceWidget
            choices={this.props.products.items}
            data={this.props.products.currentItem}
            onSelect={this.handleSelectProduct}
            renderLabel={(data) => {
              return data.title;
            }}
            renderChoice={(data) => {
              return data.title;
            }}
          />
        </div>

        <div className="t-container-header-section t-container-header-colors">
          <div className="t-container-header-label">カラー</div>
          <ChoiceWidget
            choices={this.props.products.colors}
            data={this.props.products.currentColor}
            onSelect={this.handleSelectColor}
            renderLabel={(data) => {
              return (
                <span className="dropdown-item-thumb">
                  <img src={data.image} alt={data.name} /> {data.name}
                </span>
              );
            }}
            renderChoice={(data) => {
              return (
                <span className="dropdown-item-thumb">
                  <img src={data.image} alt={data.name} /> {data.name}
                </span>
              );
            }}
          />
        </div>

        <div className="t-container-header-section">
          <div className="t-container-header-label">印刷箇所</div>

          <ButtonGroup className="t-container-header-surfaces">
            {this.props.objects.present.surfaces.map((surface) => {
              const isActive = (surface.surface.id === this.props.objects.present.currentSurface.surface.id);
              const hasObjects = (Object.keys(this.props.objects.present.objects[surface.surface.id]).length) > 0;

              let className = '';

              if (isActive) {
                className += ' active';
              }

              if (hasObjects) {
                className += ' checked';
              }

              return (
                <Button key={surface.id} className={className} onClick={this.handleSelectSurface(surface)}>
                  {surface.surface.name}
                </Button>
              );
            })}
          </ButtonGroup>
        </div>

        <div className="t-container-header-right">
          <div className="t-container-header-right-section">
            <div className="t-container-header-label">数量</div>
            <AmountSelector/>
          </div>

          {this.renderPrice()}

          <div className="t-container-header-right-button">
            {this.renderCheckoutButton()}
          </div>
        </div>
      </Navbar>
    );
  }
}

export default connect(f => f, {selectPane, selectSurface, selectColor, showCopyrightModal})(Header);


// WEBPACK FOOTER //
// ./src/containers/Header.js